<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-50 flex flex-col space-y-2">
      <TransitionGroup name="toast" tag="div" class="space-y-2">
        <div v-for="toast in toasts" :key="toast.id"
          class="px-4 py-3 rounded-lg shadow-lg max-w-sm transform transition-all duration-300 flex items-center justify-between"
          :class="[
            toast.type === 'success'
              ? 'bg-green-500 text-white'
              : toast.type === 'error'
                ? 'bg-red-500 text-white'
                : toast.type === 'warning'
                  ? 'bg-yellow-500 text-white'
                  : 'bg-blue-500 text-white',
          ]">
          <svg v-if="toast.type === 'success'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>

          <svg v-else-if="toast.type === 'error'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>

          <svg v-else-if="toast.type === 'warning'" class="w-5 h-5" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>

          <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>

          <div class="flex-1 pr-3">
            <span>{{ toast.message }}</span>
          </div>
          <div class="flex items-center space-x-2">
            <button v-if="toast.action" @click="handleAction(toast)"
              class="bg-white/20 text-white px-2 py-1 rounded text-sm">
              {{ toast.action.label }}
            </button>
            <button @click="remove(toast.id)" class="opacity-80 text-sm px-2 py-1">✕</button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script>
import { useToast } from "@/composables/useToast";

export default {
  name: "ToastNotification",
  setup() {
    const { toasts, removeToast } = useToast();

    function remove(id) {
      removeToast(id)
    }

    function handleAction(t) {
      try {
        if (t.action && typeof t.action.callback === 'function') {
          t.action.callback()
        }
      } catch (err) {
        console.warn('Toast action failed', err)
      }
      removeToast(t.id)
    }
    return { toasts, remove, handleAction };
  },
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
